// extracted by mini-css-extract-plugin
module.exports = {"slowEaseFade":"all 0.2s ease-out","collapseCaret":"CollapseCaret__collapseCaret","collapsed":"CollapseCaret__collapsed","notCollapsed":"CollapseCaret__notCollapsed"};